
// @ts-nocheck





import { i18nText } from '@/locales';


import {Modal, FormModel} from 'ant-design-vue';
import {Component} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {mixins} from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {SimpleProxyForm} from "@/UI/components/Helpers/SimpleProxyForm";
import {ClientLoyaltyTableMix} from "@/UI/mixins/Loaylty/ClientLoyaltyTableMix";
import {LoyaltyCertMix} from "@/UI/mixins/Loaylty/LoyaltyCertMix";
import {LoyaltyCertStore} from "@/store/modules/Loyalty/Cert/LoyaltyCert";
import moment from "moment";
import {TableColumns} from "@/UI/pages/loyalty/lib/table";
import {getStudioId} from '@/UI/lib/state';
import {NewProxyDataForm} from '@/UI/components/Helpers/NewProxyDataForm';
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import {ClientsMix} from '@/UI/mixins/ClientsMix';
import {
  LoyaltyCertFormData as LoyaltyCertFormData,
  FormRules as CertFormRules
} from "@/form/loyalty/loyaltyCert/LoyaltyCert";
import {showNotification} from "@/UI/lib/messages";
import {LoyaltyCertTypeStore} from "@/store/modules/Loyalty/Cert/LoyaltyCertType";
import {HandleScrollStore, HandleScrollStorewithParam, SearchinStore} from "@/UI/Decorators/decorator";
import {ICashboxListItem} from "@/entity/finance/cashbox/cashbox.types";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue";


@Component({
  components: {
    SortComponent,
    PageTitle,
    BaseDataForm,
    "a-modal": Modal,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item
  },
  methods: {moment},
})
export default class Certificates extends mixins(
  //NewProxyDataForm,
  SimpleProxyForm,
  ClientLoyaltyTableMix,
  LoyaltyCertMix,
  ClientsMix,
  TableColumns,
  ProxyGetData,
) {
  showModal = false;
  newform = new LoyaltyCertFormData();
  data: any = [];
  modalTitle = '';
  CertFormRules = CertFormRules
  showCertificateModal = false;
  modalMode = 0;

  activeTo(r: any) {
    return moment(r).format("DD.MM.YYYY");
  }

  activeFrom(r: any) {
    return moment(r).format("DD.MM.YYYY");
  }

  // create certificate
  addCert(): void {
    this.modalTitle = i18nText("Добавить сертификат");
    this.modalMode = 0;
    this.newform = new LoyaltyCertFormData();
    this.showCertificateModal = true;
    this.newform.client_id = parseInt(this.$route.params.id);
  }

  async removeCert(): Promise<void> {
    const remove_id = this.newform["id"];
    try {
      await LoyaltyCertStore.delete(Number(remove_id)).then((response) => {
        this.$notification.open({
          message: i18nText("Удаление сертификата"),
          description: response["response"],
          duration: 0,
        });
      });
    } catch (e) {
      console.log(i18nText("Ошибка удаления сертификата"));
    } finally {
      this.showCertificateModal = false;
      // await this.createProxy();
    }
  }

  cancelRemove(): void {
    //this.showUpdateModal = false;
  }

  async certificatesOnSubmit(): Promise<void> {
    (this.$refs.certForm as FormModel).validate(async (valid) => {
      if (valid) {
        try {
          //TODO::Получаем salon_id
          this.newform.salon_id = getStudioId(this);
          const response = await LoyaltyCertStore.create(this.newform);

          if (response.status) {
            showNotification(i18nText("Сертификат добавлен"), response);
            // await this.createProxy();
            this.showCertificateModal = false;
            await LoyaltyCertStore.fetchAll({
              limit: 10,
              filter: {client_id: parseInt(this.$route.params.id)},
            });
          } else {
            this.$message.error(response.response);
          }
        } catch (e) {
          console.error(e.message);
        }
      } else {
        return false;
      }
    });
  }

  async onUpdate(): Promise<void> {
    (this.$refs.certForm as FormModel).validate(async (valid) => {
      if (valid) {
        try {
          //TODO::Получаем salon_id
          this.newform.salon_id = this.$store.state["salon_id"];
          LoyaltyCertStore.update(this.newform).then((response) => {
            //TODO:: Reactive
            showNotification(i18nText("Сертификат обновлен"), response);
          });
        } catch (e) {
          console.log("Cert Updated");
          console.log(e.message);
        } finally {
          // await this.createProxy();
          this.showCertificateModal = false;
        }
      } else {
        return false;
      }
    });
  }

  @SearchinStore
  hSearch(source: string, value: string, useStudio: boolean): void {
  }

  @HandleScrollStore
  hScroll(event: any, value: string): void {
  }

  @HandleScrollStorewithParam
  hScrollParam(event: any, value: string, value2: string, useStudio: boolean): void {
  }


  handleSearchTypes(value: string): void {
    this.hSearch("loyaltyCertType", value, true);
  }

  handleSearchCashboxes(value: string): void {
    this.hSearch("cashbox", value, true);
  }

  handleScrollTypes(event: any): void {
    this.hScrollParam(event, "loyaltyCertType", "loyaltyCertTypes", true);
  }

  onCertificateTypeChange(value: number): void {
    if (this.certificateTypes && this.certificateTypes.data) {
      const currentType = this.certificateTypes.data.filter((item: Record<string, any>) => {
        return item.id == value
      })[0];
      this.newform.cashbox_sum = Number(currentType.balance);
    }
  }

  get cashbox(): any {
    return CashboxStore.items?.data;
  }

  get certificateTypes(): any {
    return LoyaltyCertTypeStore.loyaltyCertTypes
  }

  // get client(): any {
  //     return  ClientsStore.fetchData({ filter: { client_id: parseInt(this.$route.params.id) } })
  // }

  get cashboxes(): ICashboxListItem[] | undefined {
    return CashboxStore.items?.data;
  }

  certificateHandleCancel(): void {
    this.showCertificateModal = false;
  }

  async created(): Promise<void> {
    this.tableLoad = false;
    setTimeout(async () => {
      if (!this.formReady) {
        try {
          this.proxyFilter = {
            client_id: parseInt(this.$route.params.id)
          };
          await LoyaltyCertTypeStore.fetchAll({
            limit: -1,
            filter: {salon_id: getStudioId(this)},
          });

          console.log(this.certificateTypes);
          await CashboxStore.fetchAll({filter: {salon_id: getStudioId(this)}});

          appPaginationStore.setCurrent(1);
          await this.sortedData("desc", {dataIndex: "created_at"});

          this.formReady = true;
          this.tableLoad = true;
        } catch (e) {
          console.log(e)
          console.log("Error loading accounts");
        } finally {
          this.formReady = true
        }
      }
    }, 0)
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    //await this.filterData(appFiltersStore.filter);
    await this.sortedData(by, {dataIndex: sort.dataIndex});
  }

  async clearFilter(clear: string): Promise<void> {
    await this.sortedData("desc", {dataIndex: "active_from"});
  }

  subscribeHandleCancel(): void {
    this.showModal = false;
  }

  dateSale(record: Record<any, any>): string {
    return moment(record.created_at).format("DD MMMM yyyy" + " " + i18nText("в") + " " + "HH:mm");
  }

  dateActivated(record: Record<any, any>): string {
    return moment(record.created_at).format("DD MMMM yyyy" + " " + i18nText("в") + " " + "HH:mm");
  }

  dateActiveTo(record: Record<any, any>): string {
    return record.active_to
      ? moment(record.active_to).format("DD MMMM yyyy") + " " + i18nText("в") + " " + record.active_to.substr(11, 5)
      : "";
  }
}
